import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from '../apiroutes';
import { BackendListModel } from '../../models/common/list.model';
import { map, Observable } from 'rxjs';
import { DocumentModel } from 'src/app/models/document';
import { FormGroup } from '@angular/forms';
import { Documents } from 'src/app/models/chat';

@Injectable({
  providedIn: 'root'
})
export class DocumentApiService {
  base_url = ApiRoutes.Document;

  constructor(
    private http: HttpClient
  ) { }

  postDocument(doc: FormData, url = `${this.base_url}document/`) {
    // return new Observable()
    // console.log('service', doc);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data'
      })
    }
    return this.http.post<DocumentModel>(url, doc);
  }

  postChatDocument(doc: FormData, url = `${this.base_url}document/`) {
    // return new Observable()
    // console.log('service', doc);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data'
      })
    }
    return this.http.post<Documents>(url, doc);
  }

  getAllDocuments(): Observable<BackendListModel<DocumentModel>> {
    let url = `${this.base_url}document/`;
    return this.http.get<BackendListModel<DocumentModel>>(url);
  }

  getDocumentsById(id: any): Observable<BackendListModel<DocumentModel>> {
    let url = `${this.base_url}document/${id}`;
    return this.http.get<BackendListModel<DocumentModel>>(url);
  }

  deleteDocument(id) {
    let url = `${this.base_url}document/${id}/`;
    return this.http.delete(url);
  }
}
